import React from "react";
import SingleWidget from "./single-widget";

const GroupedWidget = ({ name, widgets, from, to, align }) => {
    let shouldWrap = name != null && name != "" && name != "Default";

    let cmps = [];

    for (let index = from; index <= to; index++) {
        const widget = widgets[index];
        cmps.push(<SingleWidget key={index} widget={widget} />);
    }

    if (!shouldWrap) return cmps;

    const style = align === "Right" ? { float: "right" } : {};

    return (
        <div key={name} style={style}>
            {cmps}
        </div>
    );
};

export default GroupedWidget;
